export default __webpack_public_path__ + "static/media/plurato-sailfin-efoil-2.2e7ddc99.jpg";